import {
  Breadcrumbs,
  Grid,
  Link,
  TextField,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "./index.module.css";
import TrackerTable from "./components/TrackerTable";
import logo from "../../../images/Group 1000000833.png";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ls } from "../../../variables";
import { useStateValue } from "../../../Hooks/stateProvider";
import Loader from "../../../Loader/Loader";
import { Box } from "@mui/system";
import FilterList from "../../../components/FilterList";
import { encrypt } from "../../../utils/cipher";
import DownloadDropDown from "./DownloadDropDown";
import InfoIcon from "@mui/icons-material/Info";
import { LightTooltip } from "../../../components/LightTooltip";
import SelectComponent from "../../../components/SelectComponent";
import { errorHandler } from "../../../utils/errorHandling";
import { previewValidators } from "../../../utils/validators";
import { alert } from "../../../utils/sweetAlert";
import InfoModalCMM from "../../../utils/InfoModelCMM";

const TrackerPage = (props) => {
  const navigate = useNavigate();

  const [{ pageLoading, fy_year, quarter, half_year, CMMType, totalClosed, moduleType, pmsOpenNestedList, setFilter }, dispatch] =
    useStateValue();
  // const [selectedCompliance, setSelectedCompliance] = useState("");
  const [selectedQuarter, setSelectedQuarter] = useState(quarter);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(fy_year);
  // const [selectedGuidanceType, setSelectedGuidanceType] = useState("");
  const [previewState, setPreviewState] = useState(true);
  // const [apply, setApply] = useState(false);
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openselectBox, setOpenselectBox] = useState(false);
  const [openNestedList, setOpenNestedList] = useState({
    "localCMMTypeData": [CMMType],
    "localRemarksData": [],
    "localStatusData": ['open (sebi)'],
  });
  const [selectedFundname, setSelectedFundname] = useState("");
  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPMS, setSelectedPMS] = useState([]);
  const [fileLocations, setfileLocations] = useState({});
  const [complianceStatusCount, setComplianceStatusCount] = useState({});
  const [apiStatus, setApiStatus] = useState();
  const [briefData, setBriefData] = useState({});
  const [cacheData, setCacheData] = React.useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [dataFetchFlag, setDataFetchFlag] = useState(false);
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const Year = ls.get("years");

  // Get the month name
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const handlePreviewState = (isAllSelected) => {
    if (isAllSelected) setPreviewState(true);
    else setPreviewState(false);
  };

  let type;
  const location = useLocation();
  if (
    location.pathname == "/app/cmmTracker" ||
    location.pathname == "/app/sebiCmmTracker"
  ) {
    type = "cmm";
  } 
  else (
    type = props.type
  )

  let trackerPayload;
  if (type == "cmm") {
    trackerPayload = {
      moduleType: type.toUpperCase(),
      fy_year: selectedFinancialYear,
      quarter: selectedQuarter,
      pmsName: selectedPMS,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken"),
      userType: "SEBI",
      totalClosed: totalClosed,
    };
  } 
  else {
    trackerPayload = {
      moduleType: type.toUpperCase(),
      fy_year: selectedFinancialYear,
      pmsName: selectedPMS,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken"),
      userType: "SEBI",
      totalClosed: totalClosed,
    };
  }
  useEffect(() => {
    if (briefData?.pmsName) {
      trackerPageFetch(false);
      setSelectedFundname(briefData?.pmsName);
      dispatch({ type: "pmsName", pmsName: briefData?.pmsName });
    }
  }, [briefData]);


  const getFilteredData = (element) => {
    if (type == 'cmm') {
      setFilteredRows(allRows.filter((val) => {
        if (
          openNestedList["localRemarksData"].length == 0 &&
          openNestedList["localStatusData"].length == 0 &&
          pmsOpenNestedList["localRemarksData"].length == 0 &&
          pmsOpenNestedList["localStatusData"].length == 0
        ) {
          return openNestedList["localCMMTypeData"]?.includes(val.cmm_type);
        }

        if (element) {
          const hasRemarks = element["localRemarksData"].length !== 0;
          const hasStatus = element["localStatusData"].length !== 0;
          return (
            element["localCMMTypeData"]?.includes(val.cmm_type) &&
            (!hasRemarks || element["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || element["localStatusData"]?.includes(val.status))
          );
        }
        else if (setFilter && !element) {

          const hasRemarks = openNestedList["localRemarksData"].length !== 0;
          const hasStatus = openNestedList["localStatusData"].length !== 0;

          return (
            openNestedList["localCMMTypeData"]?.includes(val.cmm_type) &&
            (!hasRemarks || openNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || openNestedList["localStatusData"]?.includes(val.status))
          );
        } else {

          const hasRemarks = pmsOpenNestedList["localRemarksData"].length !== 0;
          const hasStatus = pmsOpenNestedList["localStatusData"].length !== 0;

          return (
            pmsOpenNestedList["localCMMTypeData"]?.includes(val.cmm_type) &&
            (!hasRemarks || pmsOpenNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || pmsOpenNestedList["localStatusData"]?.includes(val.status))
          );
        }
      }));
    }
  }


  const trackerPageFetch = async (item) => {
    try {
      if (!handlePreviewClick()) {
        return;
      }
      setRows([]);
      setCacheData(false);
      dispatch({ type: "SHOW_LOADER" });
      setLoading(true);
      if (item) {
        trackerPayload["fetchResults"] = "initial";
        setSelectedFundname("");
        // setBriefData({});
      } else {
        trackerPayload["fetchResults"] = "brief";
        trackerPayload["pmsName"] = briefData?.pmsName;
      }

      const reqApiStatus = trackerPayload["fetchResults"];
      setApiStatus(trackerPayload["fetchResults"]);

      const encryptedPayload = await encrypt(trackerPayload);
      const response = await axios.post('/api/pms/trackerPageFetchAPI', { payload: encryptedPayload });

      setCacheData(response?.data?.cacheDataFlag);
      setSubmitFlag(response?.data?.submitFlag?.status);
      setSubmitMessage(response?.data?.submitFlag?.message);
      setSubmitStatus(response?.data?.submitFlag?.submited);
      setDataFetchFlag(true);
      
        dispatch({
          type: "SEBITrackerData",
          SEBITrackerData: {
            fy_year: selectedFinancialYear,
            quarter: selectedQuarter,
          },
        });

      if (reqApiStatus == 'initial') {
        if (response?.data?.emptyInitialData.length) {
          Swal.fire({
            title: "Data Not Available",
            html: response?.data?.emptyInitialData.length == 1
              ? `No Data Found for the Following PMS:<br><br><span style="font-weight: bold;">${response?.data?.emptyInitialData.join(', ')}</span></br></br>`
              : `No Data Found for the Following PMSs:<br><br><span style="font-weight: bold;">${response?.data?.emptyInitialData.join(', ')}</span></br></br>`,
            icon: "warning",
            confirmButtonColor: "#154063",
            confirmButtonText: "OK",
          });
        }
        const newRows = response?.data?.initialData.map((val, id) => {
          if (type == "cmm") {
            return {
              id: id,
              pmsName: val.pmsname,
              total_clauses: val.Total_Count,
              open_clauses: val.Open_SEBI,
              initial_response_received: val.Total_Count,
              clarification_sought: val.Open_PMS,
              final_closure_pending: (parseInt(val.Open_SEBI) + parseInt(val.Open_PMS)),
              submission_date: val.upload_date

            }
          }
        });
        dispatch({ type: "HIDE_LOADER" });
        setLoading(false);
        setRows(newRows);
        setFilteredRows(newRows)
      } else if (response?.data?.cacheDataFlag) {
        setLoading(false);
        setRows(response.data.data.map((val) => ({ ...val, id: val.cmm_id })));
        dispatch({ type: "HIDE_LOADER" });
        setFilteredRows(response.data.data.map((val) => ({ ...val, id: val.cmm_id })));
        setfileLocations(response?.data?.s3Locations);
        setComplianceStatusCount(response?.data?.complianceStatusCount);
      } else {
        setfileLocations(response?.data?.s3Locations)
        setComplianceStatusCount(response?.data?.complianceStatusCount);
        // setPreviewClicked(true);
        const newRows = response.data.data.map((val, id) => {
          if (type == "cmm") {
            // console.log("id=",val.id)
            return {
              index:val.id,
              id: val.cmm_id,
              particulars: val.particulars,
              status: val.cmm_status,
              compliance_status: val.compliance_status,
              remarks: val.cmm_remarks,
              cmm_type: val.cmm_type

            }
          }
        })
        dispatch({ type: "HIDE_LOADER" });
        dispatch({ type: "totalClosed", totalClosed: newRows.length });
        setLoading(false);

        // console.log("The CMM type",CMMType);
        setAllRows(newRows)
        if (type == 'cmm') {
          setRows(newRows.filter((val) => {
            return val.cmm_type == CMMType
          }))
          setFilteredRows(newRows.filter((val) => {
            if (openNestedList["localRemarksData"].length == 0 && openNestedList["localStatusData"].length == 0) {
              return openNestedList["localCMMTypeData"]?.includes(val.cmm_type)
            }

            const hasRemarks = openNestedList["localRemarksData"].length !== 0;
            const hasStatus = openNestedList["localStatusData"].length !== 0;

            return (
              openNestedList["localCMMTypeData"]?.includes(val.cmm_type) &&
              (!hasRemarks || openNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
              (!hasStatus || openNestedList["localStatusData"]?.includes(val.status))
            );

          }));
        } 
      }

    }
    catch (err) {
      console.log("The error", err);
      dispatch({ type: "HIDE_LOADER" });
      setLoading(false);
      errorHandler(err, navigate)
    }
  };


  const handlePreviewClick = () => {
    if (props.type === "cmm") {
      return previewValidators(selectedFinancialYear, selectedQuarter, false, "", dispatch, selectedPMS)
    } 
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filteredData = rows.filter((row) => {
      const { particulars, cmm_status } = row;
      return Object.values({ particulars, cmm_status }).some(
        (val) => val?.toString().toLowerCase().includes(query.toLowerCase())
      );
    });
    setFilteredRows(filteredData);
  };

  const handleSelectAll = (fundOptions) => {
    if (fundOptions.every((id) => selectedPMS.includes(id))) {
      setSelectedPMS([]);
    } else {
      setSelectedPMS(fundOptions);
    }
  };

  const handleSelect = (id) => {
    //if it is already available then remove, if not then add.
    if (selectedPMS.includes(id)) {
      setSelectedPMS(selectedPMS.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedPMS([...selectedPMS, id]);
    }
  };

  useEffect(() => {
    if (
      fy_year != "" &&
      (quarter != "") &&
      openNestedList["localCMMTypeData"].length != 0
    ) {
      trackerPageFetch();
    }
  }, []);
  useEffect(() => {
    // setRows([]);
    dispatch({ type: "fy_year", fy_year: selectedFinancialYear });
    dispatch({ type: "quarter", quarter: selectedQuarter });
    dispatch({ type: "pmsName", pmsName: selectedPMS });
  }, [selectedFinancialYear, selectedQuarter]);

  const finalSubmit = async () => {
    setOpenDialog(true);
    trackerPayload["pmsName"] = briefData?.pmsName;
    const encryptedPayload = await encrypt(trackerPayload)
    Swal.fire({
      icon: "warning",
      title: "Are you sure about your submission?",
      text: "Responses once recorded, shall not be reverted later.",
      showCancelButton: true,
      confirmButtonColor: "#154063",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then(async (val) => {
      if (val.isConfirmed) {
        const response = await axios.post('/api/pms/closureRecords', { payload: encryptedPayload })
        if (response?.data?.success) {
          alert("Success !!", "Your responses has been successfully captured.", "success")
          await trackerPageFetch(false);
        } else {
          alert("Your responses were not recorded.", "Please contact administrator.", "warning")
        }
      }
    }).catch((err) => {
      errorHandler(err, navigate);
    });
  }
  return (
    <>
      <InfoModalCMM
        open={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
        Year={Year}
      />

      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate("/app/welcome")}
            >
              Welcome
            </Link>
            <Link
              underline="hover"
              color="inherit"
              onClick={() => { trackerPageFetch(true) }}
            >
              {(props.type === "cmm") ? "CMM" : ""}
            </Link>
            {selectedFundname && (
              <Link underline="hover" color="inherit">
                {selectedFundname.toUpperCase()}
              </Link>
            )}
          </Breadcrumbs>
          {selectedFundname && (
            <TextField
              style={{
                height: "2rem",
                width: "clamp(10rem,20vw,30rem)",
              }}
              // id="outlined-basic"
              variant="outlined"
              placeholder="Search Table"
              // className="textfield_input"
              value={searchQuery}
              onChange={handleSearch}
            />
          )}
        </div>
        <div className={Styles.HeaderBody}>
          <div>
            <Grid container spacing={2} display="flex">
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                  <SelectComponent
                    selectedPMS={selectedPMS}
                    setSelectedPMS={setSelectedPMS}
                    selectedFinancialYear={selectedFinancialYear}
                    setSelectedFinancialYear={setSelectedFinancialYear}
                    selectedQuarter={selectedQuarter}
                    setSelectedQuarter={setSelectedQuarter}
                    pmsFlag={true}
                  />
                  <Tooltip title="View PMS Information" placement="top">
                    <IconButton
                      onClick={() => setInfoModalOpen(true)}
                      size="small"
                      sx={{
                        position: "absolute",
                        right: -38,
                        bottom: 4,
                        color: "#ffffff",
                        background: "linear-gradient(135deg, #154063 0%, #1e5a87 100%)",
                        borderRadius: "8px",
                        width: 30,
                        height: 30,
                        flexShrink: 0,
                        boxShadow: "0 2px 8px rgba(21,64,99,0.35)",
                        border: "1px solid rgba(255,255,255,0.15)",
                        "&:hover": {
                          background: "linear-gradient(135deg, #1e5a87 0%, #2570a8 100%)",
                          transform: "scale(1.12)",
                          boxShadow: "0 4px 14px rgba(21,64,99,0.45)",
                        },
                        transition: "all 0.2s ease",
                        mr:"240px"
                      }}
                    >
                      <InfoIcon sx={{ fontSize: "0.95rem" }} />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                className={Styles.dataFormButtonTracker}
                style={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "flex-end",
                  gap: "2rem",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                  {(allRows.length != 0 && apiStatus == 'brief') && <LightTooltip title={`Compliant: \t\t\t${complianceStatusCount?.compliant != "0" ? complianceStatusCount?.compliant : complianceStatusCount?.compliant}\nPartially Compliant: \t${complianceStatusCount?.partiallycompliant}\nNot Compliant: \t\t${complianceStatusCount?.notcompliant}\nCompliant(No Change): \t${complianceStatusCount?.["compliant(nochange)"]}\nNot Applicable: \t\t${complianceStatusCount?.notapplicable}`}>
                    <InfoIcon sx={{ color: "#808080", cursor: "pointer" }} />
                  </LightTooltip>}
                  <button className={Styles.Preview} onClick={() => { trackerPageFetch(true) }}>
                    APPLY
                  </button>

                  {allRows.length != 0 && apiStatus == 'brief' && (
                    <>
                      {!cacheData && (
                        <button
                          className={Styles.Preview}
                          onClick={(e) => { e.stopPropagation(); setOpenselectBox(true); }}
                        >
                          FILTER
                        </button>
                      )}
                      <DownloadDropDown
                        moduleType={props.type}
                        fileLocations={fileLocations}
                        pmsName={selectedFundname}
                      />
                      {!cacheData && (
                        <LightTooltip title={!submitFlag ? `${submitMessage}` : ""} placement="top-start">
                          <span>
                            <button
                              className={Styles.Preview}
                              disabled={!submitFlag}
                              style={{
                                backgroundColor: submitFlag ? "#154063" : "#808080",
                                cursor: submitFlag ? "pointer" : "default",
                                border: submitFlag ? "0.125rem solid #154063" : "0.125rem solid #808080",
                              }}
                              onClick={(e) => { e.stopPropagation(); finalSubmit(); }}
                            >
                              SUBMIT
                            </button>
                          </span>
                        </LightTooltip>
                      )}
                    </>
                  )}

                  {openselectBox && (
                    <Box
                      sx={{
                        bgcolor: "background.paper",
                        width: { xs: "35%", md: "30%", lg: "28%" },
                        position: "absolute",
                        right: { xs: "1.2rem", md: "2rem" },
                        backgroundColor: "#ffffff",
                        zIndex: "100",
                        boxShadow: 6,
                        marginTop: "0.5rem",
                        borderRadius: "1rem",
                        top: "14rem", 
                      }}
                    >
                      <FilterList
                        handleOpen={setOpenselectBox}
                        open={openselectBox}
                        openNestedList={openNestedList}
                        setOpenNestedList={setOpenNestedList}
                        fetchData={getFilteredData}
                        moduleType={type}
                      />
                    </Box>
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className={Styles.tableBody} style={{ position: "relative" }}>
          {!dataFetchFlag && <Loader />}
          {dataFetchFlag && (
            <TrackerTable
              type={props.type}
              previewFunc={handlePreviewState}
              status={selectedStatus}
              remarks={selectedRemarks}
              fy_year={selectedFinancialYear}
              quarter={selectedQuarter}
              rows={filteredRows}
              setRows={setRows}
              openNestedList={openNestedList}
              renderType={apiStatus}
              setApiStatus={setApiStatus}
              setBriefData={setBriefData}
              trackerPageFetch={trackerPageFetch}
              pmsName={selectedFundname}
              setFilteredRows={setFilteredRows}
              cacheData={cacheData}
              setCacheData={setCacheData}
              submitMessage={submitMessage}
              submitStatus={submitStatus}
            />
          )}
          {(pageLoading == false || pageLoading == undefined) && !dataFetchFlag && (
            <img className="image" src={logo} alt="MainImage" />
          )}
        </div>
      </div>
    </>
  );
};

export default TrackerPage;